export const PREDICTION_FIELDS = [
  { key: "goals", label: "Goals" },
  { key: "shots_on_target", label: "Shots on Target" },
  { key: "corners", label: "Corners" },
  { key: "offsides", label: "Offsides" },
  { key: "throw_ins", label: "Throw-ins" },
  { key: "fouls", label: "Fouls" },
];

export function todayISO() {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, "0");
  const d = String(now.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
